<div
  [translatable]="{
    transKey: assignedLabelTranslationKey,
    modEnum: assignedLabelTranslationModuleEnum
  }"
  class="switch-container"
>
  <label class="switch" [ngClass]="{ round: isRounded }">
    <input
      [id]="id"
      type="checkbox"
      [checked]="value"
      class="checkboxx"
      (change)="sendValue($event)"
    />
    <span class="slider"></span>
  </label>
  <label [for]="id" class="label">
    {{ label }}
        <!-- <span [ngClass]="{ 'astrix-red': isRequired, 'no-astrix': !isRequired }"> *</span> -->

  </label>
</div>

